<template>
<div>
    <Breadcrumbs main="Admin" submain="Portfolio" title="Education" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add Education</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="education_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(degree)="row">
                                        <div v-if="row.item.degree" style="max-width: 250px;">
                                            <p>{{ row.item.degree }}</p>
                                        </div>
                                    </template>

                                    <template #cell(subject)="row">
                                        <div v-if="row.item.subject" style="max-width: 250px;">
                                            <p>{{ row.item.subject }}</p>
                                        </div>
                                    </template>

                                    <template #cell(institiution)="row">
                                        <div style="max-width: 250px;" v-if="row.item.institiution">
                                            <p>{{ row.item.institiution }}</p>
                                        </div>
                                    </template>

                                    <!-- <template #cell(link)="row">
                                        <div v-if="row.item.link">
                                            <a :href="row.item.link" target="_blank" class="link-style">{{ row.item.link.substring(0,40) }}</a>
                                        </div>
                                        <div v-else>
                                            N/A
                                        </div>
                                    </template> -->

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteEducation(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editEducation(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Education Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Education" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Degree</label>
                        <input class="form-control" type="text" placeholder="Enter Educational Degree." v-model="education.degree">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Subject</label>
                        <input class="form-control" type="text" placeholder="Enter Subject" v-model="education.subject">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Institution</label>
                        <input class="form-control" type="text" placeholder="Enter Institution Name" v-model="education.institiution">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Country</label>
                        <input class="form-control" type="text" placeholder="Enter Country Name" v-model="education.country">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Passing Year</label>
                        <select class="form-control digits" v-model="education.passing_year">
                            <option v-for="(type, index) in years" :key="index" :value="type.name">{{ type.name }}</option>
                        </select>
                        <!-- <b-form-datepicker v-model="date" :date-format="yearFormat" :min="minYear" :max="maxYear" :start-year="currentYear" :end-year="currentYear + 10" no-close-on-select :show-decade-nav="true" hide-header hide-header-divider @input="updateYear"></b-form-datepicker> -->
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Education Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Education" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Degree</label>
                        <input class="form-control" type="text" placeholder="Enter Educational Degree." v-model="edit_education.degree">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Subject</label>
                        <input class="form-control" type="text" placeholder="Enter Subject" v-model="edit_education.subject">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Institution</label>
                        <input class="form-control" type="text" placeholder="Enter Institution Name" v-model="edit_education.institiution">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Country</label>
                        <input class="form-control" type="text" placeholder="Enter Country Name" v-model="edit_education.country">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Passing Year</label>
                        <select class="form-control digits" v-model="edit_education.passing_year">
                            <option v-for="(type, index) in years" :key="index" :value="type.name">{{ type.name }}</option>
                        </select>
                        <!-- <b-form-datepicker v-model="date" :date-format="yearFormat" :min="minYear" :max="maxYear" :start-year="currentYear" :end-year="currentYear + 10" no-close-on-select :show-decade-nav="true" hide-header hide-header-divider @input="updateYear"></b-form-datepicker> -->
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Gallery Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this education?</div>
    </b-modal>
</div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";
import { mapState } from 'vuex';
import loader from '../loader/loader.vue';
import { VueEditor } from "vue2-editor";

export default {
    components: {
        Datepicker,
        loader,
        VueEditor
    },

    data() {
        return {
            editor: ClassicEditor,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'degree',
                    label: 'Degree',
                    sortable: true
                },
                {
                    key: 'subject',
                    label: 'Subject',
                    sortable: true
                },
                {
                    key: 'institiution',
                    label: 'Institution',
                    sortable: true
                },
                {
                    key: 'country',
                    label: 'Country',
                    sortable: true
                },
                {
                    key: 'passing_year',
                    label: 'Passing Year',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            years: Array.from({ length: 101 }, (v, k) => ({
                id: k + 1,
                name: (new Date().getFullYear() - k).toString()
            })),

            education: {
                degree: '',
                subject: '',
                institiution: '',
                country: '',
                passing_year: ''
            },

            edit_education: {
                id: '',
                degree: '',
                subject: '',
                institiution: '',
                country: '',
                passing_year: '',
            },

            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15]
        };
    },

    computed: {
        ...mapState({
            education_list: state => state.education.education,
            loading: state => state.education.educationLoading,
            error: state => state.education.educationError
        }),

        sortOptions() {
            return this.tablefields
            .filter(f => f.sortable)
            .map(f => {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },

    mounted() {
        this.$store.dispatch("education/fetchEducation").then(() => {
            this.items = this.education_list
            this.totalRows = this.items.length;
        });
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.education.degree = null
            this.education.subject = null
            this.education.institiution = null
            this.education.country = null
            this.education.passing_year = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("education/addEducation", {
                education: this.education
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.education.degree = null
                    this.education.subject = null
                    this.education.institiution = null
                    this.education.country = null
                    this.education.passing_year = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editEducation(detail) {
            this.edit_education.id = detail.id ? detail.id : null
            this.edit_education.degree = detail.degree ? detail.degree : null
            this.edit_education.subject = detail.subject ? detail.subject : null
            this.edit_education.institiution = detail.institiution ? detail.institiution : null
            this.edit_education.country = detail.country ? detail.country : null
            this.edit_education.passing_year = detail.passing_year ? detail.passing_year : null
        },

        resetEditModal() {
            this.edit_education.degree = null
            this.edit_education.subject = null
            this.edit_education.institiution = null
            this.edit_education.country = null
            this.edit_education.passing_year = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("education/updateEducation", {
                id: this.edit_education.id,
                education: this.edit_education,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.edit_education.degree = null
                    this.edit_education.subject = null
                    this.edit_education.institiution = null
                    this.edit_education.country = null
                    this.edit_education.passing_year = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteEducation(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("education/deleteEducation", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
